import {
  AeoOnboardingStepKeySchema,
  AeoOnboardingWorkflowStatusSchema,
} from "@redotech/redo-model/aeo/onboarding";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const OnboardingWorkflowSchema = z.object({
  status: AeoOnboardingWorkflowStatusSchema,
  workflowId: z.string(),
  startedAt: z.string().nullable(),
  closedAt: z.string().nullable(),
});
export type OnboardingWorkflow = z.infer<typeof OnboardingWorkflowSchema>;

const OnboardingStepSchema = z.object({
  key: AeoOnboardingStepKeySchema,
  isComplete: z.boolean(),
});

const AeoOnboardingStateSchema = z.object({
  workflow: OnboardingWorkflowSchema.nullable(),
  steps: z.array(OnboardingStepSchema),
});
export type AeoOnboardingState = z.infer<typeof AeoOnboardingStateSchema>;

export const getAeoOnboardingState = unaryRpc({
  name: "getAeoOnboardingState",
  input: z.object({ teamId: zExt.objectId() }),
  output: AeoOnboardingStateSchema,
});
